import { AppointmentState, AppointmentCancellation } from "../../../appointment-details/appointment-details.types.js";
import { timeStringToDate, toTimeString } from "../../../../../utils/time/time.js";
import { parseISO } from "date-fns";
const mapStatusKey = (name) => {
  switch (name) {
    case AppointmentState.TREATED:
      return "stateTreatmentEnd";
    case AppointmentState.IN_TREATMENT:
      return "stateTreatmentStart";
    case AppointmentState.IN_TREATMENT_ROOM:
      return "stateInTreatmentRoomStart";
    case AppointmentState.WAITING:
      return "stateWaitingStart";
    case AppointmentState.IN_CLINIC:
      return "stateInClinicStart";
    default:
      return null;
  }
};
const toPatchRequestData = (data) => {
  const { statusSelect, cancellationReason, cancellationType, checkedStatus, roomReferenceId } = data;
  const result = (statusSelect ?? []).reduce((accumulator, { name, time }) => {
    const keyToUse = name;
    const key = mapStatusKey(keyToUse);
    const isCancellationKey = keyToUse === AppointmentState.CANCELED;
    return {
      ...accumulator,
      ...isCancellationKey && {
        cancellationType: checkedStatus === AppointmentState.CANCELED ? cancellationType : null,
        cancellationReason: checkedStatus === AppointmentState.CANCELED && cancellationReason ? cancellationReason : ""
      },
      ...key && {
        [key]: time ? timeStringToDate(time) : null
      }
    };
  }, {});
  return {
    ...result,
    roomReferenceId,
    stateControlled: data.stateControlled ? timeStringToDate(data.stateControlled) : null,
    stateControlledAccounting: data.stateControlledAccounting ? timeStringToDate(data.stateControlledAccounting) : null,
    // TODO: controlled and controlledAccounting can be removed when BE stops the support for both new and old fields
    controlled: false,
    controlledAccounting: false
  };
};
const toCancellationType = (cancellationType) => {
  if (!cancellationType)
    return null;
  const cancelledByPatientOptions = [
    AppointmentCancellation.CANCELED,
    AppointmentCancellation.CANCELED_ON_TIME,
    AppointmentCancellation.CANCELED_SHORT_TERM,
    AppointmentCancellation.CANCELED_MOVED
  ];
  if (cancelledByPatientOptions.includes(cancellationType))
    return AppointmentCancellation.CANCELED;
  return cancellationType;
};
const toFormData = (steps, stateDates) => {
  return steps.map(({ name }) => {
    const statusKey = mapStatusKey(name);
    const data = statusKey ? stateDates[statusKey] : null;
    const time = (data && toTimeString(parseISO(data))) ?? "";
    return {
      time,
      name
    };
  });
};
const getCheckedStatus = (steps, options) => {
  if (options.cancellation)
    return AppointmentState.CANCELED;
  if (options.controlled || options.controlledAccounting)
    return AppointmentState.CONTROLLED;
  const getHighestCheckedStep = steps.reduce(
    (acc, current) => {
      if (current.position === void 0)
        return acc;
      const position = current.position;
      const statusKey = mapStatusKey(current.name);
      const data = statusKey ? options.stateDates[statusKey] : null;
      return data && position > acc.position ? { position, step: current.name } : acc;
    },
    { position: -1, step: void 0 }
  );
  return getHighestCheckedStep.step;
};
const getAppointmentStatus = ({
  stateTreatmentEnd,
  stateInTreatmentRoomStart,
  stateTreatmentStart,
  stateWaitingStart,
  stateInClinicStart,
  cancellationType
}) => {
  if (cancellationType)
    return AppointmentState.CANCELED;
  if (stateTreatmentEnd)
    return AppointmentState.TREATED;
  if (stateTreatmentStart)
    return AppointmentState.IN_TREATMENT;
  if (stateInTreatmentRoomStart)
    return AppointmentState.IN_TREATMENT_ROOM;
  if (stateWaitingStart)
    return AppointmentState.WAITING;
  if (stateInClinicStart)
    return AppointmentState.IN_CLINIC;
  return AppointmentState.OPEN;
};
export {
  getAppointmentStatus,
  getCheckedStatus,
  toCancellationType,
  toFormData,
  toPatchRequestData
};
